import React, { useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import emailjs from '@emailjs/browser';

const Tasar = () => {
  const form = useRef();
  const [showMessage, setShowMessage] = useState(false);

 
const sendEmail = (e) => {
  e.preventDefault();
  const btn = document.getElementById("button");
  btn.value = "Enviando...";

  // --- 1. Send email via EmailJS ---
  emailjs.sendForm(
      'service_a29n4ya',
      'template_b810tso',
      form.current,
      'ZMdUwEUf5EG6H0nSS'
  )
  .then(() => {
      // --- 2. Reset form and show success message ---
      btn.value = "Enviar";
      form.current.reset();
      setShowMessage(true);
      setTimeout(() => {
          setShowMessage(false);
      }, 3000);
  }, (err) => {
      btn.value = "Enviar";
      alert(JSON.stringify(err));
  });
};
  return (
    <div>
      <Helmet>
        <title>Tasación gratuita de tu coche | Manacars</title>
        <meta name="description" content="Tasamos tu vehículo gratis y sin compromiso. Vende o cambia tu coche con Manacars, en Oyón (Álava)." />
        <link rel="canonical" href="https://manacars.es/tasacion" />
      </Helmet>
      {showMessage && (
        <div className="success-message">
          ¡Mensaje enviado con éxito!
        </div>
      )}
      <div id="container1">
        <h1 className="form-title2">&bull; Tasación &bull;</h1>
        <div className="underline"></div>
        <p style={{textAlign: 'center', margin: '20px'}}>¿Quieres vender o cambiar tu coche? En Manacars te hacemos una tasación gratuita y sin compromiso. Rellena el formulario con los datos de tu vehículo y te enviamos una valoración a tu correo. Si decides vender, nos encargamos de todo el proceso.</p>
        <form id="form" className='form23' ref={form} onSubmit={sendEmail}>
        <div className="field">
          <label for="to_name">Nombre</label>
          <input type="text" name="to_name" id="to_name" />
        </div>
        <div className="field">
          <label for="from_name">Email</label>
          <input type="email" name="email" id="from_name" />
        </div>
        <div className="telephone">
          <label for="name">Teléfono</label>
          <input type="text" name="telephone" id="telephone_input" required />
        </div>
        <div className="postal">
          <label for="postal">Código postal</label>
          <input type="number" name="postal" id="postal_input" required />
        </div>
        <div className="marca">
          <label for="marca">Marca vehículo y modelo</label>
          <input type="text" name="marca" id="marca_input" required />
        </div>
        <div className="matricula">
          <label for="matricula">Año de 1ª matriculación</label>
          <input
            type="number"
            placeholder=""
            name="matricula"
            id="matricula_input"
            required
          />
        </div>
        <div className="potencia">
          <label for="potencia">Potencia CV</label>
          <input type="text" name="potencia" id="potencia_input" required />
        </div>
        <div className="kilometros">
          <label for="kilometros">Kilómetros del vehículo</label>
          <input type="text" name="kilometros" id="kilometros_input" required />
        </div>
        <div>
          <div>
            <label for="cambio-select">Cambio</label>
            <select name="cambio" id="cambio-select" required>
               <option value="">--Seleccione una opción--</option> 
              <option value="manual">Manual</option>
              <option value="automatico">Automático</option>
            </select>
          </div>
          <div>
            <label for="procedencia-select">Procedencia</label>
            <select name="procedencia" id="procedencia-select" required>
               <option value="">--Seleccione una opción--</option> 
              <option value="nacional">Nacional</option>
              <option value="importacion">Importación</option>
            </select>
          </div>
          <div>
            <label for="revisiones-select">Libro revisiones</label>
            <select name="revisiones" id="revisiones-select" required>
               <option value="">--Seleccione una opción--</option> 
              <option value="si">Sí</option>
              <option value="no">No</option>
            </select>
          </div>
          <div>
            <label for="combustible-select">Combustible</label>
            <select name="combustible" id="combustible-select" required>
               <option value="">--Seleccione una opción--</option> 
              <option value="gasolina">Gasolina</option>
              <option value="diesel">Diesel</option>
              <option value="electrico">Eléctrico</option>
              <option value="hibrido">Híbrido</option>
            </select>
          </div>
          <input type="checkbox" id="cbox2" value="second_checkbox" required />
          <label for="cbox2">De acuerdo con la política de privacidad</label>
        </div>
        <div className="message">
          <label for="message"></label>
          <textarea
            name="message"
            placeholder="Buenas,quisiera tasar mi coche..."
            id="message_input"
            cols="30"
            rows="5"
            required
          ></textarea>
        </div>
        <input className="button" type="submit" id="button" value="Enviar" />
      </form>
      </div>
    </div>
  )
}

export default Tasar
